<template>
    <div class="box">
        <div class="field">
            <p class="title">Password Reset</p>
        </div>
        <hr style="margin-left:25px;margin-right:25px;"/>

        <table>
            <tr>
                <td>
                    <b class="textlabel">New Password</b>
                </td>
                <td style="width:100%">
                    <input id="password" class="textfield" type="password" v-model="password"></input>
                </td>
            </tr>
            <tr>
                <td>
                    <b class="textlabel">Retype Password</b>
                </td>
                <td style="width:100%">
                    <input id="repassword" class="textfield" type="password" v-model="repassword" @keydown.enter="reset()"></input>
                </td>
            </tr>
        </table>

        <div class="field">
            <button type="button" v-on:click="reset()">Reset Password</button>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        krypto: ''
    },
	data() {
		return {
            password: '',
            repassword: ''
		}
	},
	methods: {
        reset() {
            api.postData(
                {
                    type:"verify",
                    data:{
                        pageid:PAGES.RESET_PASSWORD_PAGE,
                        data:[
                            this.password,
                            this.repassword,
                            this.krypto,
                        ]
                    }
                }
            ).then((res) => {
                if(res.data.errors.length>0) {
                    var message = '';
                    for(var i = 0;i<res.data.errors.length;i++){
                        message+="• "+res.data.errors[i]+'\n';
                    }
                    alert("𝗘𝗿𝗿𝗼𝗿\n\n"+message);
                }else{
                    alert('Your password has been changed, you will now be redirected to the login page');
                    router.push('/0200');
                }
	        });
        }
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    width:100%;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

button.link {
    background:none;
    border:none;
    color:#0066dd;
    text-decoration: underline;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Password_Reset.vue